import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import {
  DocumentSchema,
  FieldDataType,
  SchemaField,
  SystemFieldNames,
  SystemFieldType
} from 'src/app/modules/core/store/models/document.model';
import { DataApiService as DataMartApiService } from 'src/app/modules/analytics/store/data/data-api.service';
import { DatasetSubtype, DatasetType } from 'src/app/modules/core/store/models/dataset.model';
import { catchError, map } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import { WidgetSourceType } from '../store/dashboards';

@Injectable({
  providedIn: 'root'
})
export class SchemaQueryService {
  constructor(private dataMartApiService: DataMartApiService) {}

  public getSchema(type: DatasetType, subtype: DatasetSubtype): Observable<DocumentSchema> {
    if (type === DatasetType.ActivityLog) {
      return this.getActivityLogSchema();
    }
    return this.getDatasetFieldsSchema(type, subtype);
  }

  private getDatasetFieldsSchema(type: DatasetType, subtype: DatasetSubtype): Observable<DocumentSchema> {
    return this.dataMartApiService.getAnalyticsFields(type, subtype).pipe(
      catchError(e => {
        console.error(e);
        return of(null);
      }),
      map(data => {
        if (data) {
          return {
            fields: data
          } as DocumentSchema;
        } else {
          return null;
        }
      })
    );
  }

  private getActivityLogSchema(): Observable<DocumentSchema> {
    var schema = {
      fields: []
    } as DocumentSchema;

    schema.fields.push({
      uId: uuidv4(),
      systemName: 'event_type_display',
      displayName: 'Event Type',
      fieldType: SystemFieldType.System | SystemFieldType.Editable,
      dataType: FieldDataType.Text,
      picklistValues: []
    } as SchemaField);

    schema.fields.push({
      uId: uuidv4(),
      systemName: 'site_display',
      displayName: 'Site',
      fieldType: SystemFieldType.System | SystemFieldType.Editable,
      dataType: FieldDataType.Text,
      picklistValues: []
    } as SchemaField);

    schema.fields.push({
      uId: uuidv4(),
      systemName: 'action_taken',
      displayName: 'Action Taken',
      fieldType: SystemFieldType.System | SystemFieldType.Editable,
      dataType: FieldDataType.Text,
      picklistValues: [],
      settings: {
        format: 'FORMAT-TEXT-MULTILINE'
      }
    } as SchemaField);

    schema.fields.push({
      uId: uuidv4(),
      systemName: 'resolution_display',
      displayName: 'Resolution',
      fieldType: SystemFieldType.System | SystemFieldType.Editable,
      dataType: FieldDataType.Text,
      picklistValues: []
    } as SchemaField);

    schema.fields.push({
      uId: uuidv4(),
      systemName: SystemFieldNames.dateCreated,
      displayName: 'Date Created',
      fieldType: SystemFieldType.System,
      dataType: FieldDataType.DateTime
    } as SchemaField);

    schema.fields.push({
      uId: uuidv4(),
      systemName: SystemFieldNames.createdBy,
      displayName: 'Created By',
      fieldType: SystemFieldType.System,
      dataType: FieldDataType.User
    } as SchemaField);

    schema.fields.push({
      uId: uuidv4(),
      systemName: SystemFieldNames.dateUpdated,
      displayName: 'Date Updated',
      fieldType: SystemFieldType.System,
      dataType: FieldDataType.DateTime
    } as SchemaField);

    schema.fields.push({
      uId: uuidv4(),
      systemName: SystemFieldNames.updatedBy,
      displayName: 'Updated By',
      fieldType: SystemFieldType.System,
      dataType: FieldDataType.User,
      settings: {
        defaultValue: 'RECURRING-CURRENT-USER-UID'
      }
    } as SchemaField);

    return of(schema);
  }
}
